module.exports = __webpack_public_path__ + "static/Ranger - How to Create a New Report-4763bb11b59d2910f082a6998c4b394c.pdf";